// extracted by mini-css-extract-plugin
export var blueDiagonal = "Layout-module--blueDiagonal--2ee7f";
export var bottom = "Layout-module--bottom--c6f94";
export var bottomOuter = "Layout-module--bottomOuter--c4fa1";
export var siteMain = "Layout-module--siteMain--08ba8";